import axios from 'axios';
import store from 'store';
import { logoutAction } from 'store/actions';
import { authStorage } from 'services/security/authStorage';
const PROD_API = 'https://resources-utilization-api.herokuapp.com/api/v1';
const LOCAL_API = 'http://localhost:8080/api/v1';

// Prefer REACT_APP_API_URL when set (e.g. in .env.local). Otherwise use prod in
// production builds and local API during development.
let apiHost = process.env.REACT_APP_API_URL || LOCAL_API;
if (!process.env.REACT_APP_API_URL && process.env.NODE_ENV === 'production') {
  apiHost = PROD_API;
}

const axiosWithAuthToken = () => {
  const authToken = authStorage.getAuthToken();
  const instance = axios.create({
    baseURL: apiHost,
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : {}
  });
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (err) {
      const staffToken = authStorage.getAuthToken();
      const sentToken = err.config?.headers?.Authorization?.replace(/^Bearer\s+/i, '');
      if (err.response?.status === 401 && staffToken && sentToken && sentToken === staffToken) {
        store.dispatch(logoutAction());
      }
      return Promise.reject(err);
    }
  );
  return instance;
};

// Invite-flow only: never send the portal staff token to feedback-token APIs
const axiosWithFeedbackToken = () => {
  const idToken = localStorage.getItem('idToken');
  return axios.create({
    baseURL: apiHost,
    headers: idToken ? { Authorization: `Bearer ${idToken}` } : {}
  });
};

const axiosWithBaseUrl = () =>
  axios.create({
    baseURL: apiHost
  });

export const axiosInstances = {
  withAuthToken: axiosWithAuthToken,
  withFeedbackToken: axiosWithFeedbackToken,
  withBaseUrl: axiosWithBaseUrl
};
